import { render, staticRenderFns } from "./FacilityTheme1.vue?vue&type=template&id=ece36b4a&scoped=true"
import script from "./FacilityTheme1.vue?vue&type=script&lang=js"
export * from "./FacilityTheme1.vue?vue&type=script&lang=js"
import style0 from "./FacilityTheme1.vue?vue&type=style&index=0&id=ece36b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece36b4a",
  null
  
)

export default component.exports